export enum UserTypes {
    Customer = 'customer',
    //TODO: add other types
  }
